import EntityDetailsProvider from '@shared/components/details/entity-details-provider/entity-details-provider.vue';
import EntityCard from '@shared/components/details/entity-card/entity-card.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ActivityChangesInterface } from '@tools/interfaces/activity-log';
@Component({
  name: 'bpc-activity-changes',
  components: {
    'bpc-entity-card': EntityCard,
    'bpc-entity-details-provider': EntityDetailsProvider,
  },
})
export default class ActivityChanges extends Vue {
  @Prop(Object) readonly changes: ActivityChangesInterface;
  @Prop(String) readonly description: string;
  @Prop(String) readonly entity: string;

  public showChanges: boolean = false;

  get oldTreeview() {
    if (this.changes.old) {
      return this.parseObject2Treeview(this.changes.old, 0);
    } else {
      return [];
    }
  }

  get attributesTreeview() {
    if (this.changes.attributes) {
      return this.parseObject2Treeview(this.changes.attributes, 0);
    } else {
      return [];
    }
  }

  get createdAction(): boolean {
    return this.description === 'created';
  }

  get deletedAction(): boolean {
    return this.description === 'deleted' || this.description === 'soft-deleted';
  }

  get softDeletedAction(): boolean {
    return this.description === 'soft-deleted';
  }

  parseObject2Treeview(object: object, id: number) {
    let newId = id;
    return Object.keys(object).reduce((tree, prop) => {
      if (Array.isArray(object[prop])) {
        newId++;
        tree.push({
          id: newId,
          name: `${prop}:`,
          children: object[prop].map(subObject => {
            newId++;
            return this.parseObject2Treeview(subObject, newId);
          }),
        });
        return tree;
      } else if (typeof object[prop] === 'object' && object[prop] !== null) {
        newId++;
        tree.push({
          id: newId,
          name: `${prop}:`,
          children: this.parseObject2Treeview(object[prop], newId),
        });
        return tree;
      } else {
        newId++;

        tree.push({
          id: newId,
          name: `${prop}: ${object[prop]}`,
        });

        return tree;
      }
    }, []);
  }

  toggleShowChanges() {
    this.showChanges = !this.showChanges;
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
